export default {
  treeStatistic: [],
  forests: [],

  animalTable: [],
  animalStatistic: [],
  animalsTypes: [],
  animals: [],
};
